import { __exports as guards } from "../../../../../../../_virtual/guards.js";
import { __require as requireTypes } from "./types.js";
var hasRequiredGuards;
function requireGuards() {
  if (hasRequiredGuards) return guards;
  hasRequiredGuards = 1;
  guards.__esModule = true;
  guards.isComment = guards.isCombinator = guards.isClassName = guards.isAttribute = void 0;
  guards.isContainer = isContainer;
  guards.isIdentifier = void 0;
  guards.isNamespace = isNamespace;
  guards.isNesting = void 0;
  guards.isNode = isNode;
  guards.isPseudo = void 0;
  guards.isPseudoClass = isPseudoClass;
  guards.isPseudoElement = isPseudoElement;
  guards.isUniversal = guards.isTag = guards.isString = guards.isSelector = guards.isRoot = void 0;
  var _types = requireTypes();
  var _IS_TYPE;
  var IS_TYPE = (_IS_TYPE = {}, _IS_TYPE[_types.ATTRIBUTE] = true, _IS_TYPE[_types.CLASS] = true, _IS_TYPE[_types.COMBINATOR] = true, _IS_TYPE[_types.COMMENT] = true, _IS_TYPE[_types.ID] = true, _IS_TYPE[_types.NESTING] = true, _IS_TYPE[_types.PSEUDO] = true, _IS_TYPE[_types.ROOT] = true, _IS_TYPE[_types.SELECTOR] = true, _IS_TYPE[_types.STRING] = true, _IS_TYPE[_types.TAG] = true, _IS_TYPE[_types.UNIVERSAL] = true, _IS_TYPE);
  function isNode(node) {
    return typeof node === "object" && IS_TYPE[node.type];
  }
  function isNodeType(type, node) {
    return isNode(node) && node.type === type;
  }
  var isAttribute = isNodeType.bind(null, _types.ATTRIBUTE);
  guards.isAttribute = isAttribute;
  var isClassName = isNodeType.bind(null, _types.CLASS);
  guards.isClassName = isClassName;
  var isCombinator = isNodeType.bind(null, _types.COMBINATOR);
  guards.isCombinator = isCombinator;
  var isComment = isNodeType.bind(null, _types.COMMENT);
  guards.isComment = isComment;
  var isIdentifier = isNodeType.bind(null, _types.ID);
  guards.isIdentifier = isIdentifier;
  var isNesting = isNodeType.bind(null, _types.NESTING);
  guards.isNesting = isNesting;
  var isPseudo = isNodeType.bind(null, _types.PSEUDO);
  guards.isPseudo = isPseudo;
  var isRoot = isNodeType.bind(null, _types.ROOT);
  guards.isRoot = isRoot;
  var isSelector = isNodeType.bind(null, _types.SELECTOR);
  guards.isSelector = isSelector;
  var isString = isNodeType.bind(null, _types.STRING);
  guards.isString = isString;
  var isTag = isNodeType.bind(null, _types.TAG);
  guards.isTag = isTag;
  var isUniversal = isNodeType.bind(null, _types.UNIVERSAL);
  guards.isUniversal = isUniversal;
  function isPseudoElement(node) {
    return isPseudo(node) && node.value && (node.value.startsWith("::") || node.value.toLowerCase() === ":before" || node.value.toLowerCase() === ":after" || node.value.toLowerCase() === ":first-letter" || node.value.toLowerCase() === ":first-line");
  }
  function isPseudoClass(node) {
    return isPseudo(node) && !isPseudoElement(node);
  }
  function isContainer(node) {
    return !!(isNode(node) && node.walk);
  }
  function isNamespace(node) {
    return isAttribute(node) || isTag(node);
  }
  return guards;
}
export {
  requireGuards as __require
};
//# sourceMappingURL=guards.js.map
